import { AdvComModule } from 'jk-advcom';
import { Component, Injector, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MtrwlService,  } from './../_service_mtr';
import { MaterialModule } from 'jk-service';
import { MtrwlEditComponent } from './../_edit_mtr';
import { UiModeType, PageKind, } from 'jk-service';
import { jkSingleComponent, JkaggridComponent } from 'jk-advcom';
import { JackBaseComponentModule } from 'jk-service';



@Component({
  selector: 'app-mtrki01-detail',
  standalone: true,
  imports: [
    MaterialModule,
    JackBaseComponentModule,
    AdvComModule,
  ],
  templateUrl: './mtrki01-detailPkg.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: [],
})
export class Mtrki01DetailComponent extends jkSingleComponent implements OnInit {
  override _programId = 'mtrki01-detail';
  override masterSrv = new MtrwlService();
  override get srv(): MtrwlService {
    return this.masterSrv;
  }
  constructor() {
    super();
    this.pageKind = PageKind.detail;
    this.uiMode = UiModeType.dialog;  //dialog 'tab';
    this.srv.programId = this.programId + '-detail'; // ### modi,不要亂改
    this.srv.linkMasterFields = 'WL001=WD001';
    this.masterEditPage = MtrwlEditComponent;
    this.gridInitOpt = { programId: this.programId, sortField: 'WL005', sort: 'desc', defaultSort: null, pageKind: this.pageKind };
    this.srv.programId = 'stock'; // ### modi,不要亂改

    //this.constructorInit(); // ###

  }
  override async constructorInit() {
    await super.constructorInit();
    this.masterSrv.cdr = this.cdr;
  };

  override onWindowResize($event?: any) {
    super.onWindowResize($event);
  }

  override async ngAfterViewInit() {
    await super.ngAfterViewInit();
    this.setMasterService();
  }

}
